import React from 'react';
import MMAComp from './MMA.component';

class MMA extends React.Component {
    componentDidMount() {
        MMAComp();
    }
    render() {
        return (
            <div>
            </div>
        )
    }
}

export default MMA;